import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OriginalRegistrationStatsGraphComponent } from '../../departments/recruiting/original-registration-stats-graph/original-registration-stats-graph.component';
import { RegistrationProgressComponent } from '../../departments/recruiting/registration-progress/registration-progress.component';
import { UiModule } from 'src/app/ui/ui.module';
import { IconService } from 'src/app/ui/icon.service';
import { DataPadService } from 'src/app/ui/data-pad/data-pad.service';
import { LocalAuthService } from 'src/app/auth/local-auth.service';

@Component({
  selector: 'app-registration-stats',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    OriginalRegistrationStatsGraphComponent,
    RegistrationProgressComponent,
    UiModule
  ],
  templateUrl: './registration-stats.component.html',
  styleUrl: './registration-stats.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegistrationStatsComponent {
  
  // Role-based computed property for PPM goal settings access
  canEditPpmGoals = computed(() => {
    return this.auth.hasAnyRole(['it', 'salesAdmin']);
  });
  
  constructor(
    public icons: IconService,
    private dataPadService: DataPadService,
    private auth: LocalAuthService
  ) {}

  updateRegistrationGoals() {
    this.dataPadService.showPanel({
      panelName: 'updateRegistrationGoals',
      inputData: {}
    });
  }
  
} 